import { HTTP } from '@/services/axios';

export async function getGalleries({filterText,filterCategory,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Gallery/getGalleryList.php',{
        params:{
            filterText,
            filterCategory,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getGallery({galleryId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Gallery/getGalleryData.php?galleryId=${galleryId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getGalleryInfo({galleryId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Gallery/getGalleryInfo.php?galleryId=${galleryId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getGalleryOptions(){
    let result = [];
    
    await HTTP({
        method: 'get',
        url: '/app/core/Gallery/getGalleryOptions.php'
    })
    .then(response => {
        result = response.data.result;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function unlockGallery({galleryId}){
    let result = {};

    var data = {'myRecordID':galleryId};

    await HTTP({
        method: 'patch',
        url: '/app/core/Gallery/controlGalleryUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateGallery({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Gallery/controlGalleryChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function setDefaultPhotoToGallery({galleryId,photoId}){
    let result = {};
   
    var data = {'galleryId':galleryId,'photoId':photoId}

    await HTTP({
        method: 'patch',
        url: '/app/core/Gallery/controlGallerySetDefaultPhoto.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createGallery({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Gallery/controlGallerySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveGallery({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Gallery/controlGallerySave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteGallery({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Gallery/controlGalleryDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}